<template>
  <div v-loading="loading" class="app-manage">
    <el-page-header :content="title" @back="emit('back')" />

    <div v-for="g in groups" :key="g.name" class="group">
      <div class="group-title">{{ g.name }}</div>
      <el-row :gutter="16">
        <el-col v-for="t in g.items" :key="t.label" :lg="4" :md="6" :sm="8" :xs="12">
          <el-card class="tile" shadow="hover" @click="t.action">
            <el-tag v-if="t.kind === 'export'" class="tile-export" size="small" type="warning">导出</el-tag>
            <el-icon :size="26">
              <component :is="t.icon" />
            </el-icon>
            <div class="tile-label">{{ t.label }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'AppManageGrid',
    props: {
      groups: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
    },
    emits: ['back'],
    setup(props, { emit }) {
      return { emit }
    },
  })
</script>

<style lang="scss" scoped>
  .app-manage {
    padding: 16px;
  }

  .group {
    margin-top: 24px;
  }

  .group-title {
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
  }

  .tile {
    position: relative;
    cursor: pointer;
    text-align: center;
    transition: all 0.2s;

    &:hover {
      transform: translateY(-2px);
    }

    .tile-label {
      margin-top: 8px;
      font-size: 13px;
      color: #606266;
    }
  }

  .tile-export {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
  }
</style>
